import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup} from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { EnforcementService } from 'src/app/core/services/enforcement.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-enforcement-historical',
  templateUrl: './enforcement-historical.component.html',
  styleUrls: ['./enforcement-historical.component.css']
})
export class EnforcementHistoricalComponent implements OnInit {

  isArabic!: boolean;
    @Input() enforcementList: any;
    userData: any;
    form!: FormGroup;
    enforcementDetail: any[] = [];
    enforcementId?: string;  
  
     constructor( private router: Router,              
      private storageService: StorageService,
      private commonService: CommonService,
      private fb: FormBuilder,
      private enforcementService: EnforcementService
      ) { }
  
    ngOnInit(): void {
      this.isArabic = this.storageService.getSessionStorageData('isArabic');
      this.userData = this.storageService.getSessionStorageData('userDetails');
      this.form = this.fb.group({
        enforcement: [''] // default empty
      });
      const requestData = {
        assessmentUnitGuid: this.userData?.assessmentUnitValue,
      };
       this.form = this.fb.group({
        enforcement: ['']
      });
  
      this.enforcementService.fetchEnforcementHistory(requestData).subscribe(
        (res) => {
          if (res?.data) {
            const decryptedData = this.commonService.decryptUsingAES256(res?.data);
            const VOID_STATUS_CODE = 755020006;
            const PARTIALLY_PAID_STATUS_CODE = 755020005; 
            const PAID_STATUS_CODE = 755020004;
            const CLOSED_STATUS_CODE = 755020001; 
            const CANCELLED_STATUS_CODE = 755020002;

            // The array to filter the records you want to keep
            const filteredRecords = decryptedData.filter((item: any) => 
              item.mde_enforcementstatus === VOID_STATUS_CODE || 
              item.mde_enforcementstatus === PARTIALLY_PAID_STATUS_CODE || 
              item.mde_enforcementstatus === PAID_STATUS_CODE ||
              item.mde_enforcementstatus === CLOSED_STATUS_CODE ||
              item.mde_enforcementstatus === CANCELLED_STATUS_CODE
            );
            this.enforcementDetail = JSON.parse(JSON.stringify(filteredRecords));
          }
        },
        (error: any) => {
          console.error('Error fetching enforcement detail', error);
        }
      );
    
     
    }
   
     onListItemClick(selectedItemIdx: number) {
      this.enforcementList.forEach((v: any, i: any) => {
        if (i === selectedItemIdx) {
          v.isActive = true;
        } else {
          v.isActive = false;
        }
      });
       if (this.enforcementList[selectedItemIdx].link !== '') {
        let path = 'executor-dashboard/' + this.enforcementList[selectedItemIdx].link;
        this.router.navigate([path]);
      }
    }

    goToDetail(enforcementId: string) {
      if (enforcementId) {
        this.storageService.setSessionStorageData('enforcementId', enforcementId);
        this.storageService.setSessionStorageData('isHistorical', true);
        this.router.navigate(
          ['/executor-dashboard/enforcement/detail'],
          { state: { enforcementId: enforcementId, isHistorical: true } }
        );
      } else {
        alert(this.isArabic ? 'يرجى تحديد التقييم أولاً.' : 'Please select an assessment first.');
      }
    }
  
  }
